export enum ActionType {
  CREATE = 'create',
  EDIT = 'edit',
  DELETE = 'delete',
  VIEW = 'view',
}

export enum UpdateTabType {
  CURRENT = 'current',
  UPDATE = 'update',
}
